import { ActionTree } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { UserState, SignupUserPayload, SigninUserPayload } from "./types";
import { RootState } from "../../types";
import { User } from "@dokogd/shared";
import { currentApp } from "../../../utils/firebase";

const init = "init";
const signup = "signup";
const signin = "sigin";
const signout = "signout";
const updateProfile = "updateProfile";

const n = {
  init,
  signup,
  signin,
  signout,
  updateProfile,
};

export const actions: ActionTree<UserState, RootState> = {
  async [n.init](context, payload) {
    console.log("init UserState:start");
    console.log("user", n.init, payload);
    window.TheFirebase = await currentApp(context);

    console.log("init UserState:done");
  },
  async [n.signup](_context, payload: SignupUserPayload) {
    const displayName = payload.username.trim();
    const app = await currentApp();
    const userCred = await app
      .auth()
      .createUserWithEmailAndPassword(
        payload.email.trim(),
        payload.password.trim()
      );
    console.log("User", userCred);
    const user = userCred.user;
    if (user) {
      // Set display name
      await user.updateProfile({
        displayName,
        photoURL: `https://doko-goes-digital.web.app/img/avatars.svg#avatar-${payload.avatarId}`,
      }); //         .catch(err => console.error("Failed to set displayName", err));
      console.log("updateProfile");

      // Init user
      const userDocRef = app.firestore().collection("users").doc(user.uid);
      const userSetupData: User<firebase.firestore.FieldValue> = {
        displayName,
        friends: [],
        avatarId: payload.avatarId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        lookingForADesk: firebase.firestore.FieldValue.serverTimestamp(),
      };
      await userDocRef.set(userSetupData);
      console.log("userSetupData", userSetupData);
    }
  },
  async [n.signin](_context, payload: SigninUserPayload) {
    const userCred = await (await currentApp())
      .auth()
      .signInWithEmailAndPassword(
        payload.email.trim(),
        payload.password.trim()
      );
    console.log("User", userCred);
  },
  async [n.signout](_context, _payload) {
    await (await currentApp()).auth().signOut();
  },
  async [n.updateProfile](_context, payload: Partial<SignupUserPayload>) {
    console.log("UPDATE PROFILE", payload);
    const app = await currentApp();
    const user = app.auth().currentUser;
    if (user) {
      if (payload.avatarId || payload.username) {
        await user.updateProfile({
          displayName: payload.username,
          photoURL: payload.avatarId
            ? `https://doko-goes-digital.web.app/img/avatars.svg#avatar-${payload.avatarId}`
            : undefined,
        });

        const updateData: firebase.firestore.UpdateData = {};
        if (payload.avatarId) {
          updateData.avatarId = payload.avatarId;
        }
        if (payload.username) {
          updateData.displayName = payload.username;
        }

        await app
          .firestore()
          .collection("users")
          .doc(user.uid)
          .update(updateData);
        await user.getIdTokenResult(true);
      }

      if (payload.password) {
        user.updatePassword(payload.password);
      }

      if (payload.email) {
        user.updateEmail(payload.email);
      }
    }
  },
};

export const actionNames = n;
